module.exports = __webpack_public_path__ + "static/about_agencyvista4-e8af8bf5bbe3bb16223bed5300e684de.png";